// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__6bKtd","item":"PaymentsMobile_item__1zd8h","label":"PaymentsMobile_label__2OhAO","amount":"PaymentsMobile_amount__OjAIR"};